import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { buildParams } from "../../utils/admin-utils";
import { formatHolidayResponse } from "../../utils/holiday-utils";

export function useHolidays() {
	const [holidays, setHolidays] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function fetchHolidays(pagination = {}) {
		try {
			setLoading(true);
			setError(null);

			const { accessToken, clientId } = getAuthParams();
			const params = buildParams(pagination);

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/feriados?${params.toString()}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					}
				}
			);

			if (!response.ok) {
				await throwResponseError(response, "Erro ao buscar feriados.");
			}

			const data = await response.json();
			const holidaysData = data.resultado || [];

			const responsePagination = {
				totalElements: data.totalElementos ?? 0,
				totalPages: data.totalPaginas ?? 0,
				page: data.pagina ?? 0,
				size: data.tamanho ?? pagination.size ?? 10
			};

			const formattedHolidays = Array.isArray(holidaysData)
				? holidaysData.map(formatHolidayResponse)
				: [];

			setHolidays(formattedHolidays);

			return {
				ok: true,
				empty: formattedHolidays.length === 0,
				holidays: formattedHolidays,
				pagination: responsePagination
			};
		} catch (requestError) {
			setHolidays([]);
			setError(requestError.message);

			return {
				ok: false,
				reason: "request",
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		holidays,
		loading,
		error,
		refetch: fetchHolidays
	};
}